import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { logoutProcess } from "../../../utils/Authentication/AppLogout";
import { SignOut } from "../../../actions/Dashboard";
import { getUserDataByKey } from "../../../utils/Authentication/handleUserSession";
import { routePrefix } from "../../../constants/Routes";
import profile_icon from "../../../assets/images/admin-portal/profile-icon.svg";
import "./EcoproModal.css";
import { UNIQUE_ID_GA } from "../../../constants/AppConstants";
import { useMsal } from "@azure/msal-react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const EcoproModal = ({ role, exactRole = null }) => {
  const { t } = useTranslation(["translation", "CSAgenttranslation"]);
  const dispatch = useDispatch();
  const currentURL = useLocation();
  const { accounts } = useMsal();
  const MSALAccountName = (accounts.length > 0) ? accounts[0].name : null;

  /**
   * Method to check whether current page is admin or csagent page
   * to display text with proper translations
   * @returns boolean
   */
  const checkISAdminByPath = () => {
    return (currentURL?.pathname.indexOf(routePrefix.CSAGENT) > -1 || currentURL?.pathname.indexOf(routePrefix.ADMIN) > -1) ? true : false;
  }
  /**
   * Method to signout from the application
   */
  const handleLogout = () => {
    dispatch(SignOut());
    logoutProcess();
  };

  const getUserDisplayName = () => {
    const userName = getUserDataByKey('displayName', 'personal_details');
    return (!userName) ? `${getUserDataByKey('firstName', 'personal_details')} ${getUserDataByKey('lastName', 'personal_details')}` : userName;
  };
  
  const displayName = getUserDisplayName().trim();
  const emailID = getUserDataByKey('emailAddress', 'personal_details');
  const [show, setShow] = useState(false);
  
  const closeModal = () => {
    setShow(!show);
  };

  const agentHeader = (
    <Popover.Header as="h3">
      <div className="container">
        <div className="row">
          <div className="col popover-user">
             <div className="f-16 popover-name">
                  {
                    checkISAdminByPath() 
                    ? `${t('CSAgenttranslation:CS_AGENT_HEADER_POPUP.USER_PROFILE.HELLO')} ${displayName || MSALAccountName}` 
                    : `${t("DASHBOARD.USER_PROFILE.HELLO")} ${displayName || MSALAccountName}`
                  }
              </div>
            {emailID && <div className="f-12 popover-mail">{emailID}</div>}
          </div>
        </div>
      </div>
    </Popover.Header>
  );

  const popoverFooter = (
    <div className="user-options">
      <div
        className="sign-out f-14 pointer-cursor ta-left fw-b"
        onClick={() => handleLogout()}
        id={UNIQUE_ID_GA.customerLogout}
      >
        { (checkISAdminByPath()) ? t("CSAgenttranslation:CS_AGENT_SIGN_OUT") : t("DASHBOARD.USER_PROFILE.SIGN_OUT")}
      </div>
    </div>
  );

  const csAgentPopover = (
    <Popover id="popover-positioned-bottom" className={`agent-popover ${exactRole === 'admin' ? 'admin-popover' : "not-admin-popover"}`}>
      {agentHeader}
      {popoverFooter}
    </Popover>
  );

  const csAgentProfile = (
    <div className="profile-icon">
      <img
        id="user-profile-backdrop"
        src={profile_icon}
        alt="profile"
        onClick={() => closeModal()}
      />
    </div>
  );

  return (
      <>
        <OverlayTrigger
              trigger="click"
              placement="bottom"
              overlay={csAgentPopover}
              rootClose
              rootCloseEvent="click"
              show={show}
            >
            {csAgentProfile}
        </OverlayTrigger>
      </>
  );
};

export default EcoproModal;
